import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import posthog, { PostHogConfig } from 'posthog-js';

import { CONFIG_TOKEN } from '@core/tokens';

@Injectable({
  providedIn: 'root',
})
export class PostHogService {
  readonly #platformId = inject(PLATFORM_ID);
  readonly #config = inject(CONFIG_TOKEN);
  #initialized = false;

  public get posthog(): typeof posthog {
    if (isPlatformBrowser(this.#platformId) && this.#initialized) {
      return posthog;
    }

    return new Proxy({} as typeof posthog, {
      get: () => () => undefined,
    });
  }

  public init(): void {
    if (!isPlatformBrowser(this.#platformId) || this.#initialized) {
      return;
    }

    if (!this.#config.posthog) {
      console.warn('PostHog is disabled because posthog key and host are missing from config.json.');
      return;
    }

    posthog.init(this.#config.posthog.key, {
      api_host: this.#config.posthog.host,
      logs: {
        serviceName: 'optimo-frontend',
        environment: this.#config.appEnvironmentId,
      },
    } satisfies Partial<PostHogConfig>);
    this.#initialized = true;
  }
}
